import React from 'react';
import ParliamentRedirect from '../ParliamentRedirect/ParliamentRedirect';

const PokerParliament: React.FC = () => {
    return <ParliamentRedirect parliamentName="Poker Parliament" />;
};

export default PokerParliament;
